import http from "./http.js";

export default {
  // ---------- User / Login ----------
  userGet(payload) {
    const id = payload.id ?? "";
    return http.get(`/userget/${payload.action}/${id}`);
  },
  userPost(payload) {
    return http.post("/userpost", { payload });
  },

  // ---------- Termin (öffentlich) ----------
  terminGet(payload) {
    const id = payload.id ?? "";
    return http.get(`/termin/get/${payload.action}/${id}`);
  },
  terminPost(payload) {
    return http.post("/termin/post", { payload });
  },

  // ---------- Termin (Admin) ----------
  terminAdminGet(payload) {
    const id = payload.id ?? "";
    const qs = payload.query
      ? "?" + new URLSearchParams(payload.query).toString()
      : "";
    return http.get(`/admin/termin/get/${payload.action}/${id}${qs}`);
  },
  terminAdminPost(payload) {
    return http.post("/admin/termin/post", { payload });
  },

  // ---------- Telefon (Admin) ----------
  phoneStatus() {
    return http.get("/admin/phone/status");
  },
  phoneToken() {
    return http.get("/admin/phone/token");
  },
  phoneCalls(bookingId) {
    const qs = bookingId ? `?booking_id=${bookingId}` : "";
    return http.get(`/admin/phone/calls${qs}`);
  },
  phoneCall(payload) {
    return http.post("/admin/phone/call", { payload });
  },
  phoneSid(payload) {
    return http.post("/admin/phone/sid", { payload });
  },
  phoneConnected(payload) {
    return http.post("/admin/phone/connected", { payload });
  },
  phoneEnded(payload) {
    return http.post("/admin/phone/ended", { payload });
  },
  phonePoll(payload) {
    return http.post("/admin/phone/poll", { payload });
  },
  phoneVmList(params) {
    const qs = params ? "?" + new URLSearchParams(params).toString() : "";
    return http.get(`/admin/phone/vm${qs}`);
  },
  phoneVmPost(payload) {
    return http.post("/admin/phone/vm", { payload });
  },

  // ---------- Inbox / FastMail (Admin) ----------
  mailGet(action, id = "", params = null) {
    const qs = params ? "?" + new URLSearchParams(params).toString() : "";
    return http.get(`/admin/mail/get/${action}/${id}${qs}`);
  },
  mailPost(payload) {
    return http.post("/admin/mail/post", { payload });
  },
  mailAttachmentUrl(mattId) {
    return `${http.defaults.baseURL}/admin/mail/attachment/${mattId}`;
  },
};
